import React from 'react';
import { Paper, Subheader } from 'material-ui';
import { Divider } from 'material-ui';
import ItemRow from '../ItemRow';
import {
  isItemDispenser,
  getRateForFrequency,
  getFullItemName,
  getItemFromOrder
} from '../../../../utils/mrs-util';
import './ItemGroup.css';

const ItemGroup = (props) => {
  const fillItemOnOrder = getItemFromOrder(
    props.group.item,
    props.mrsOrder,
    props.groupId
  );

  const customerFrequency = props.customer.mrsCustomer.minFrequency;
  const frequency =
    fillItemOnOrder?.frequency ||
    (isItemDispenser(props.group.item)
      ? '0'
      : Math.max(props.group.item.defaultFrequency,customerFrequency).toString());
  const rate =
    fillItemOnOrder?.adjustedPrice?.priceItem ||
    getRateForFrequency(props.group.item, frequency, customerFrequency);

  return (
    <div className="item-group-container">
      <Subheader className="subheader2">{props.group.item.description}</Subheader>
      <Paper>
        <ItemRow
          item={props.group.item}
          toggleItem={(add) => {
            if (add) {
              props.addItem(props.group.item);
            } else {
              props.removeItem(fillItemOnOrder.mrsOrderLineItemId);
            }
          }}
          qty={fillItemOnOrder?.quantity || 1}
          frequency={frequency}
          rate={rate}
          checked={!!fillItemOnOrder?.quantity > 0}
          handleEditClick={() =>
            props.handleEditClick(
              props.group,
              props.group.item,
              fillItemOnOrder
            )
          }
        />
        <Divider />
        {props.group.dispensers.map((item, index, array) => {
          const lastElement = index == array.length - 1;

          const dispenserOnOrder = getItemFromOrder(
            item,
            props.mrsOrder,
            props.groupId
          );

          const frequency =
            dispenserOnOrder?.frequency || (isItemDispenser(item) ? '0' : '1');
          const rate =
            dispenserOnOrder?.adjustedPrice?.priceItem ||
            getRateForFrequency(item, frequency, props.customer.mrsCustomer.minFrequency);

          return (
            <React.Fragment key={item.id}>
              <ItemRow
                item={item}
                toggleItem={(add) => {
                  if (add) {
                    props.addItem(item);
                  } else {
                    props.removeItem(dispenserOnOrder.mrsOrderLineItemId);
                  }
                }}
                qty={dispenserOnOrder?.quantity || 1}
                frequency={frequency}
                rate={rate}
                checked={dispenserOnOrder?.quantity > 0}
                handleEditClick={() =>
                  props.handleEditClick(props.group, item, dispenserOnOrder)
                }
              />
              {!lastElement ? <Divider /> : null}
            </React.Fragment>
          );
        })}
      </Paper>
      {props.error && <div className="item-group-error">{props.error}</div>}
    </div>
  );
};

export default ItemGroup;
